/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { HealthResponseFromJSON, VersionResponseFromJSON, } from '../models/index';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * Health
     */
    healthApiV1HealthGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/health`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => HealthResponseFromJSON(jsonValue));
        });
    }
    /**
     * Health
     */
    healthApiV1HealthGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.healthApiV1HealthGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hello
     */
    helloGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => HealthResponseFromJSON(jsonValue));
        });
    }
    /**
     * Hello
     */
    helloGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.helloGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Version
     */
    versionApiV1VersionGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/version`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Version
     */
    versionApiV1VersionGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.versionApiV1VersionGetRaw(initOverrides);
            return yield response.value();
        });
    }
}
